import { useContext } from 'react'
import type { UseCasesSimplifiedReturn } from '@/types'
import { casesContext } from '../contexts/cases-context'

export const useCases = (): UseCasesSimplifiedReturn => {
  const context = useContext(casesContext)

  if (!context) {
    throw new Error('useCases must be used within CasesProvider')
  }

  return context
}
